import styled, { css } from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
import { Color as PColor } from '../../utils/types/palette';
import { BorderRadiusSize as BRSize } from '../../utils/types/shape';
import { Variant } from './types';
var baseClassName = 'ModalTitle';
var Icon = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'Icon')
}).withConfig({
  componentId: "sc-l3tf49-0"
})(function (_ref) {
  var palette = _ref.theme.palette;
  return css(["display:flex;margin-bottom:8px;padding:14.5px;border-radius:50%;background:", ";color:", ";"], palette[PColor.Accent_1_2_Opacity], palette[PColor.AccentStateless]);
});
var LabelPrimary = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'LabelPrimary')
}).withConfig({
  componentId: "sc-l3tf49-1"
})(function (_ref2) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? Variant.Default : _ref2$variant;
  return css(["font-size:18px;line-height:27px;font-weight:", ";"], variant === Variant.Default ? 400 : 500);
});
var LabelSecondary = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'LabelSecondary')
}).withConfig({
  componentId: "sc-l3tf49-2"
})(["font-size:12px;line-height:14px;margin-top:4px;"]);
var Close = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'Close')
}).withConfig({
  componentId: "sc-l3tf49-3"
})(function (_ref3) {
  var _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? Variant.Default : _ref3$variant,
    palette = _ref3.theme.palette;
  return css(["position:absolute;display:flex;top:", "px;right:", "px;color:", ";&:hover{color:", ";}cursor:pointer;"], variant === Variant.WithIcon ? 2 : 8, variant === Variant.WithIcon ? 2 : 8, palette[PColor.IconsSecondary], palette[PColor.AccentPrimary]);
});
var ModalTitle = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-l3tf49-4"
})(function (_ref4) {
  var _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? Variant.Default : _ref4$variant,
    _ref4$theme = _ref4.theme,
    palette = _ref4$theme.palette,
    borderRadius = _ref4$theme.shape.borderRadius;
  return css(["position:relative;color:", ";border-radius:", " ", " 0px 0px;", " ", " ", ""], palette[PColor.TextPrimary], borderRadius[BRSize.Md], borderRadius[BRSize.Md], function () {
    var paddingY = variant === Variant.WithIcon ? 26 : 14;
    var paddingX = variant === Variant.WithIcon ? 12 : 14;
    var paddingLeft = 18;
    var paddingRight = variant === Variant.WithIcon ? paddingLeft : 40;
    return css(["padding:", "px ", "px ", "px ", "px;"], paddingY, paddingRight, paddingX, paddingLeft);
  }, variant === Variant.Default && css(["background:", ";border-bottom:1px solid ", ";"], palette[PColor.BackgroundPrimary], palette[PColor.BordersSecondary]), variant === Variant.WithIcon && css(["display:flex;align-items:center;flex-direction:column;"]));
});
var Styled = applyDisplayNames({
  ModalTitle: ModalTitle,
  LabelPrimary: LabelPrimary,
  LabelSecondary: LabelSecondary,
  Close: Close,
  Icon: Icon
});
export default Styled;